module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ico_gradient/silver-ico-gradient-b0967528c36e8f7df07e35979e013718.svg";